import './fonts';
import './bootstrap';
import '../../css/app.css';
import '@xyflow/react/dist/style.css';
import 'react-toastify/dist/ReactToastify.css';

import Cookies from 'universal-cookie';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ToastContainer } from 'react-toastify';
import { clarity } from 'react-microsoft-clarity';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

// Providers
import { AppModalProvider } from './provider/AppModal/AppModal.provider';

// Redux
import { store } from './store';

// Analytics
import analytics from './analytics';

Sentry.init({
    dsn: 'https://fbc84dcea9876bbb9fe4c5df16563034@o4507311208136704.ingest.de.sentry.io/4508993522368592',
    enabled: import.meta.env.PROD,
    debug: import.meta.env.DEV,
    environment: import.meta.env.DEV ? 'development' : 'production',
});

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => {
        if (
            title.startsWith('ReelFlow Dashboard') ||
            title.startsWith('ReelFlow Login') ||
            title.startsWith('ReelFlow Forgot')
        ) {
            return title;
        }

        return `${title} – ${appName}`;
    },
    resolve: (name) => {
        return resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob('./Pages/**/*.tsx'),
        );
    },
    setup({ el, App, props }) {
        const content = (
            <Provider store={store}>
                <AppModalProvider>
                    <SentryErrorBoundary fallback={undefined}>
                        <App {...props} />
                        <ToastContainer />
                    </SentryErrorBoundary>
                </AppModalProvider>
            </Provider>
        );

        if (import.meta.env.DEV) {
            createRoot(el).render(content);

            return;
        }

        hydrateRoot(el, content);
    },
    progress: {
        color: '#4B5563',
    },
});

router.on('success', (event) => {
    // @ts-ignore
    if (event.detail.page && process.env.NODE_ENV === 'production') {
        analytics.page();

        clarity.init('mvyxjf5eqj');
    }

    const cookieMap = new Cookies(document.cookie);

    cookieMap.set('reelflow_ref_count', '1', { path: '/' });
});

router.on('navigate', () => {
    const cookieMap = new Cookies(document.cookie);

    cookieMap.set('reelflow_ref_count', '1', { path: '/' });
});
